// ============================================================================
// CART SOURCE TRACKING
// ----------------------------------------------------------------------------
// Every cart add gets two hidden line item properties so we can attribute
// orders in the admin/GraphQL:
//
//   _source — which button / app added the item
//   _page   — URL path the user was on when it happened (e.g. /collections/foo)
//
// Leading underscore = hidden from customer-facing cart/checkout/emails but
// persisted on the order. Queryable via Admin GraphQL lineItems.customAttributes.
// NOT queryable via Shopify admin Orders search (admin search rejects
// line_items.properties.*) — use GraphQL or saved filter views.
//
// _source vocabulary:
//   THEME_atc     — theme Add to Cart form (product or collection card)
//   THEME_bn      — theme Buy Now button (this file, below)
//   THEME_qb      — theme Quick Buy button (snippets/quick-buy-button.liquid)
//   EP_addon      — Essential Products PRODUCT_ADDON checkbox item
//   EP_target     — Essential Products FBT main product (Claim Offer button)
//   EP_bundled    — Essential Products FBT bundle partner (non-target item)
//
// Naming rule: THEME_* = native theme button; EP_* = attributable to the
// Essential Products app; future apps follow XX_* pattern.
//
// *** FIVE IMPLEMENTATION SITES — change the shape, update all five: ***
//
//   1. snippets/product__form.liquid      — hidden inputs (ATC, product page)
//   2. snippets/quickAddToCartForm.liquid — hidden inputs (ATC, collection card)
//   3. snippets/quick-buy-button.liquid   — inline in $.ajax data payload (QB)
//   4. assets/custom.js (below)           — inline in Buy Now payload (BN)
//   5. assets/custom.js (EPA wrapper)     — window.fetch wrapper tags EP_*
//
// Why five sites:
//   • THEME_atc uses static Liquid hidden inputs because $form.serialize() in
//     z__jsAjaxCart.js picks them up automatically — no JS required, and the
//     stable XHR submit flow stays untouched.
//   • THEME_bn and THEME_qb use JS payloads because those handlers build the
//     fetch body themselves (they don't go through a <form>).
//   • EP_* is tagged via a window.fetch wrapper because EPA is a theme app
//     extension — it calls /cart/add.js from its own compiled bundle, no theme
//     code runs. The wrapper inspects __essential_upsell_* markers on items to
//     distinguish target / addon / bundled. Theme buttons use jQuery $.ajax
//     (XHR, not fetch), so the wrapper is invisible to them — that's why
//     ATC/BN/QB tag themselves directly.
//
// Inlined intentionally — no shared helper. Previously had window.cartSource()
// but QB (in a separate file) gained a cross-file dependency on custom.js
// parsing correctly, which was a new regression risk. Inlining is cheap, the
// shape is stable, and each call site reads as what it sends.
// ============================================================================ 


// Buy Now: monogram validated here directly (see monogram-input.liquid for full strategy)
$(document).on("click","[data-buy-now]",function(e){
  e.preventDefault();
  var id = $(this).attr("data-id");
  var monogramInput = document.querySelector('[data-monogram-input]');
  // Block if monogram exists, is required (enabled), but empty. applyState()
  // disables the input on variants that don't require a monogram; a disabled
  // input means "not required" so Buy Now should proceed. Null when no block.
  if (monogramInput && !monogramInput.disabled && monogramInput.value.length === 0) {
    monogramInput.focus();
    monogramInput.classList.add('monogram-input__field--error');
    var errorMsg = document.querySelector('[data-monogram-error]');
    if (errorMsg) errorMsg.style.visibility = 'visible';
    return false;
  }
  var payload = {
    id: id,
    quantity: 1,
    properties: { _source: 'THEME_bn', _page: window.location.pathname }
  };
  if (monogramInput && !monogramInput.disabled && monogramInput.value) {
    payload.properties.Monogram = monogramInput.value;
  }
  // Hidden per-variant note property (independent of the monogram). The
  // [data-variant-note] input is disabled when the variant has no note.
  var noteInput = document.querySelector('[data-variant-note]');
  if (noteInput && !noteInput.disabled && noteInput.value) {
    payload.properties._Note = noteInput.value;
  }
  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: JSON.stringify(payload),
    contentType: 'application/json',
    dataType: 'json',
    success: function(cartData) {
      window.location.href = '/checkout';
    },
    error: function(xhr, status, error) {
      console.log(error);
    }
  });
});

// EPA cart-source tagging. Wraps window.fetch to tag Essential Products
// upsell items (EP_target / EP_addon / EP_bundled). See header comment at
// top of file for the full system. Installs AFTER EPA — EPA's guard only
// checks its own flag, so if we patch first it overwrites us. Polls for
// window._essentialUpsellFetchOverridden up to 2s, then installs anyway
// (wrapper is a no-op on pages with no EP markers, so fallback is safe).
// Every operation wrapped in try/catch — on ANY error, falls through to
// the original unmodified fetch. Never breaks a cart add.
(function installCartFetchWrapper() {
  function install() {
    var prevFetch = window.fetch;
    window.fetch = function(resource, init) {
      try {
        var url = (resource && resource.url) || String(resource || '');
        if (!/\/cart\/add\.js(\?|$)/.test(url)) return prevFetch.apply(this, arguments);
        if (!init || typeof init.body !== 'string') return prevFetch.apply(this, arguments);
        var body = JSON.parse(init.body);
        var page = window.location.pathname;
        var items = Array.isArray(body.items) ? body.items : (body.id ? [body] : null);
        if (!items) return prevFetch.apply(this, arguments);
        var hasFbtTarget = items.some(function(it) {
          return it && it.properties && it.properties.__essential_upsell_is_target_product;
        });
        items.forEach(function(item) {
          item.properties = item.properties || {};
          if (item.properties._source) return;
          var isTarget = !!item.properties.__essential_upsell_is_target_product;
          var hasFunnelId = !!item.properties.__essential_upsell_funnel_id;
          if (!isTarget && !hasFunnelId) return;
          if (isTarget) item.properties._source = 'EP_target';
          else if (hasFbtTarget) item.properties._source = 'EP_bundled';
          else item.properties._source = 'EP_addon';
          item.properties._page = page;
        });
        var newInit = Object.assign({}, init, { body: JSON.stringify(body) });
        return prevFetch.call(this, resource, newInit).then(function(response) {
          // After EPA's cart-add succeeds, tell the Horizon cart to refresh itself.
          // CART-HACK: #12 — dispatch CartAddEvent after EPA add. See CART-TRANSPLANT.md #12.
          try {
            if (response && response.ok && window.cartIntegration && window.cartIntegration.refreshCart) {
              window.cartIntegration.refreshCart('epa');
            }
          } catch (e) { /* swallow — never break EPA */ }
          return response;
        });
      } catch (err) {
        return prevFetch.apply(this, arguments);
      }
    };
  }
  if (window._essentialUpsellFetchOverridden) return install();
  var tries = 0;
  var timer = setInterval(function() {
    if (window._essentialUpsellFetchOverridden || ++tries > 40) {
      clearInterval(timer);
      install();
    }
  }, 50);
})();

/*
 * Judge.me Review Pinning and Hiding
 * Runs on any page where the current product has UUIDs in its
 * custom.judgeme_pinned_reviews metafield and/or the shop has UUIDs in its
 * store-wide custom.judgeme_hidden_reviews metafield (both written into the
 * page by layout/theme.liquid).
 * Finds whatever Judge.me review widget is on the page, fetches that
 * widget's product's reviews, drops reviews whose UUIDs are in the hidden
 * list, pins reviews whose UUIDs are in the pinned list, and draws the
 * result with its own pager. UUIDs that don't match any review in the
 * widget's pool are silently ignored. A UUID in both lists stays hidden.
 *
 * layout/theme.liquid starts the review list and pager invisible on these
 * pages, because Judge.me's served first page could contain a hidden
 * review; reveal() is the only thing that reveals them, and only after
 * Judge.me's own setup has run (class jdgm--done-setup-widget / event
 * jdgm.doneSetup), so the list never shows unformatted. From the moment the
 * list box and pager first lay out until reveal(), they are held at that
 * height, so the page below them moves once. If the API fetch fails, the
 * reviews Judge.me served in the page are drawn through the same path, so
 * Judge.me's own render never shows on these pages.
 * The header's star box and average start invisible the same way, and
 * finishHeader() rounds the average to one decimal (Judge.me prints two) and
 * shows them the moment Judge.me's setup is done, before the fetch returns.
 * "Judge.me's setup is done" is read once, by onJudgemeReady(): Judge.me adds
 * jdgm--done-setup-widget to the widget in the same script run that shows its
 * title, and a MutationObserver on that class fires after that run and before
 * the next paint, so what the module reveals appears in the same frame as
 * Judge.me's title. The header's layout is CSS in custom.css (JOE section).
 *
 * The review pool comes from Judge.me's documented widget endpoint on
 * cdn.judge.me (/api/v1/widgets/product_review), authenticated with the
 * shop's public Judge.me token in the query string (the CDN rejects the
 * header form). The token and the shop's .myshopify.com domain are written
 * into the page by layout/theme.liquid. Every page of the pool is requested
 * at once; the page count comes from the widget's data-number-of-reviews.
 * Any failure is logged to the console and draws the served reviews.
 */
(function() {
  // --- CONFIG ---
  var PINNED_IDS = window.__jdgmPinnedReviews || [];
  var HIDDEN_IDS = window.__jdgmHiddenReviews || [];
  var PUBLIC_TOKEN = window.__jdgmPublicToken;
  var SHOP_DOMAIN = window.__jdgmShopDomain;
  var PER_PAGE = 5;
  var API_PER_PAGE = 30;  // the endpoint's maximum
  // --- END CONFIG ---

  if (!PINNED_IDS.length && !HIDDEN_IDS.length) return;

  var widget = document.querySelector('.jdgm-review-widget[data-id]');
  if (!widget) return;

  var reviewsContainer = widget.querySelector('.jdgm-rev-widg__reviews');
  if (!reviewsContainer) return;

  // Judge.me's served first page, copied before renderPage() empties the
  // container. The fallback draws from it if the API fetch fails.
  var servedReviews = Array.prototype.map.call(
    reviewsContainer.querySelectorAll('.jdgm-rev'),
    function(rev) { return rev.cloneNode(true); }
  );

  // Boxes held at their first laid-out height until reveal(); see holdBox().
  var heldBoxes = [];
  var holdObserver = null;
  holdWhenLaidOut([reviewsContainer, widget.querySelector('.jdgm-paginate')]);

  // Callbacks for the moment Judge.me's own setup is done; see onJudgemeReady().
  var readyCallbacks = [];
  var readyObserver = new MutationObserver(function() {
    if (!judgemeIsReady()) return;
    readyObserver.disconnect();
    var fns = readyCallbacks;
    readyCallbacks = [];
    fns.forEach(function(fn) { fn(); });
  });
  readyObserver.observe(widget, { attributes: true, attributeFilter: ['class'] });
  onJudgemeReady(finishHeader);

  var PRODUCT_ID = widget.getAttribute('data-id');
  if (!PRODUCT_ID) {
    drawList(servedReviews);
    return;
  }

  var apiBase = 'https://cdn.judge.me/api/v1/widgets/product_review'
    + '?shop_domain=' + encodeURIComponent(SHOP_DOMAIN)
    + '&api_token=' + encodeURIComponent(PUBLIC_TOKEN)
    + '&external_id=' + encodeURIComponent(PRODUCT_ID)
    + '&per_page=' + API_PER_PAGE;

  // Judge.me's count includes star-only reviews, which the endpoint never
  // returns, so the last page can come back short or empty.
  function readReviewCount() {
    var summary = widget.querySelector('.jdgm-rev-widg');
    var text = summary ? summary.getAttribute('data-number-of-reviews') : null;
    if (!/^\d+$/.test(text || '')) {
      throw new Error('Judge.me widget has no usable data-number-of-reviews');
    }
    return parseInt(text, 10);
  }

  // An error status or a malformed body must reach the fallback, not draw
  // an empty list.
  function fetchPage(page) {
    return fetch(apiBase + '&page=' + page).then(function(r) {
      if (!r.ok) throw new Error('Judge.me product_review returned ' + r.status);
      return r.json();
    }).then(function(data) {
      if (typeof data.widget !== 'string') {
        throw new Error('Judge.me product_review returned an unexpected body');
      }
      var temp = document.createElement('div');
      temp.innerHTML = data.widget;
      return Array.prototype.slice.call(temp.querySelectorAll('.jdgm-rev'));
    });
  }

  // Every page at once; the count says how many pages there are.
  function fetchAllReviews() {
    var count = readReviewCount();
    if (count === 0) return [];
    var fetches = [];
    for (var page = 1; page <= Math.ceil(count / API_PER_PAGE); page++) {
      fetches.push(fetchPage(page));
    }
    return Promise.all(fetches).then(function(pages) {
      var allReviews = Array.prototype.concat.apply([], pages);
      if (!allReviews.length) {
        throw new Error('Judge.me product_review returned no reviews for a count of ' + count);
      }
      return allReviews;
    });
  }

  // Promise.resolve().then() so an error thrown by readReviewCount() reaches
  // the same catch as a failed request.
  Promise.resolve()
    .then(fetchAllReviews)
    .then(function(allReviews) {
      drawList(allReviews);

      // Intercept sort dropdown (hidden but preserved for future use)
      var sortDropdown = widget.querySelector('.jdgm-sort-dropdown');
      if (sortDropdown) {
        sortDropdown.addEventListener('change', function(e) {
          e.stopImmediatePropagation();
          var sortVal = sortDropdown.value;
          sortReviews(widget, sortVal);
          renderPage(widget, 1);
        }, true);
      }
    })
    .catch(function(err) {
      // Fallback: draw the reviews Judge.me served in the page, through the
      // same filter and order, so a hidden review can't appear here either.
      console.error('Judge.me pin/hide module:', err);
      drawList(servedReviews);
    });

  // Drop hidden reviews, put pinned ones first in metafield order, the rest
  // newest first, and draw page 1. Hidden reviews are dropped before pins are
  // picked out, so a UUID in both lists stays hidden.
  function drawList(reviews) {
    var visible = reviews.filter(function(rev) {
      return HIDDEN_IDS.indexOf(rev.getAttribute('data-review-id')) === -1;
    });

    var pinned = [];
    PINNED_IDS.forEach(function(id) {
      for (var i = 0; i < visible.length; i++) {
        if (visible[i].getAttribute('data-review-id') === id) {
          pinned.push(visible[i]);
          break;
        }
      }
    });
    var unpinned = visible.filter(function(rev) {
      return PINNED_IDS.indexOf(rev.getAttribute('data-review-id')) === -1;
    });

    // Default-sort unpinned group by most-recent so Judge.me-side
    // pinned reviews don't stay at the top by API-response order.
    unpinned.sort(function(a, b) {
      return reviewTimestamp(b).localeCompare(reviewTimestamp(a));
    });

    // Store for sorting
    widget._allReviews = pinned.concat(unpinned);
    widget._pinnedIds = PINNED_IDS;

    renderPage(widget, 1);
  }

  function reviewTimestamp(rev) {
    var el = rev.querySelector('.jdgm-rev__timestamp');
    return (el && el.getAttribute('data-content')) || '';
  }

  // Holds the list box and pager at the height they first lay out with, so the
  // page below them moves once, at reveal(), no matter what happens inside
  // them before that (the fetch, our redraw, Judge.me formatting the served
  // reviews). Judge.me keeps the widget body display:none until its own
  // stylesheet arrives, so a box may have no size yet when this runs; a
  // ResizeObserver then reports its first laid-out size. The held height is
  // the box's own offsetHeight as border-box, so the hold never changes the
  // box's size (and the observer never has to report a change we caused).
  // State lives in heldBoxes / holdObserver, declared at the top of the module
  // because holdWhenLaidOut() runs before this point in the source.
  function holdBox(el) {
    if (heldBoxes.indexOf(el) !== -1) return;
    heldBoxes.push(el);
    el.style.boxSizing = 'border-box';
    el.style.height = el.offsetHeight + 'px';
    el.style.overflow = 'hidden';
  }

  function holdWhenLaidOut(boxes) {
    boxes = boxes.filter(Boolean);
    boxes.forEach(function(el) { if (el.offsetHeight > 0) holdBox(el); });
    var pending = boxes.filter(function(el) { return heldBoxes.indexOf(el) === -1; });
    if (!pending.length) return;
    holdObserver = new ResizeObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.target.offsetHeight > 0) holdBox(entry.target);
      });
      if (pending.every(function(el) { return heldBoxes.indexOf(el) !== -1; })) {
        holdObserver.disconnect();
        holdObserver = null;
      }
    });
    pending.forEach(function(el) { holdObserver.observe(el); });
  }

  function releaseBoxes() {
    if (holdObserver) { holdObserver.disconnect(); holdObserver = null; }
    heldBoxes.forEach(function(el) {
      el.style.height = '';
      el.style.overflow = '';
      el.style.boxSizing = '';
    });
    heldBoxes = [];
  }

  function sortReviews(widget, sortVal) {
    var pinned = [];
    var unpinned = [];
    widget._allReviews.forEach(function(rev) {
      var id = rev.getAttribute('data-review-id');
      if (widget._pinnedIds.indexOf(id) !== -1) {
        pinned.push(rev);
      } else {
        unpinned.push(rev);
      }
    });

    // Sort unpinned only — pinned stay in config order
    unpinned.sort(function(a, b) {
      switch (sortVal) {
        case 'highest-rating':
          return parseInt(b.querySelector('[data-score]').getAttribute('data-score'))
               - parseInt(a.querySelector('[data-score]').getAttribute('data-score'));
        case 'lowest-rating':
          return parseInt(a.querySelector('[data-score]').getAttribute('data-score'))
               - parseInt(b.querySelector('[data-score]').getAttribute('data-score'));
        case 'most-recent':
          return (b.querySelector('.jdgm-rev__timestamp').getAttribute('data-content') || '')
            .localeCompare(a.querySelector('.jdgm-rev__timestamp').getAttribute('data-content') || '');
        case 'with-pictures':
        case 'pictures-first':
          var aPics = a.querySelectorAll('.jdgm-rev__pic-img').length;
          var bPics = b.querySelectorAll('.jdgm-rev__pic-img').length;
          if (sortVal === 'with-pictures') {
            return bPics - aPics;
          }
          if (bPics !== aPics) return bPics - aPics;
          return (b.querySelector('.jdgm-rev__timestamp').getAttribute('data-content') || '')
            .localeCompare(a.querySelector('.jdgm-rev__timestamp').getAttribute('data-content') || '');
        case 'videos-first':
          var aVids = a.querySelectorAll('.jdgm-rev__vid').length;
          var bVids = b.querySelectorAll('.jdgm-rev__vid').length;
          if (bVids !== aVids) return bVids - aVids;
          return (b.querySelector('.jdgm-rev__timestamp').getAttribute('data-content') || '')
            .localeCompare(a.querySelector('.jdgm-rev__timestamp').getAttribute('data-content') || '');
        case 'most-helpful':
          var aUp = parseInt(a.getAttribute('data-thumb-up-count') || 0);
          var bUp = parseInt(b.getAttribute('data-thumb-up-count') || 0);
          return bUp - aUp;
        default:
          return 0;
      }
    });

    // Re-sort pinned to match config order
    pinned.sort(function(a, b) {
      return widget._pinnedIds.indexOf(a.getAttribute('data-review-id'))
           - widget._pinnedIds.indexOf(b.getAttribute('data-review-id'));
    });

    widget._allReviews = pinned.concat(unpinned);
  }

  function renderPage(widget, page) {
    var reviews = widget._allReviews;
    var total = reviews.length;
    var totalPages = Math.ceil(total / PER_PAGE);
    var start = (page - 1) * PER_PAGE;
    var end = Math.min(start + PER_PAGE, total);

    var container = widget.querySelector('.jdgm-rev-widg__reviews');
    container.innerHTML = '';
    for (var i = start; i < end; i++) {
      var clone = reviews[i].cloneNode(true);
      var revId = clone.getAttribute('data-review-id');

      // Strip any pre-existing pin indicator — metafield is the sole source of truth
      var existingPin = clone.querySelector('.jdgm-rev__pinned');
      if (existingPin) existingPin.parentNode.removeChild(existingPin);
      clone.classList.remove('jdgm-rev--pinned');

      // Add our pin indicator only if this review is in the metafield list
      if (PINNED_IDS.indexOf(revId) !== -1) {
        var pinSpan = document.createElement('span');
        pinSpan.className = 'jdgm-rev__pinned';
        var timestamp = clone.querySelector('.jdgm-rev__timestamp');
        if (timestamp) {
          timestamp.parentNode.insertBefore(pinSpan, timestamp.nextSibling);
        }
      }
      container.appendChild(clone);
    }

    // Build pagination
    var paginate = widget.querySelector('.jdgm-paginate');
    if (!paginate) {
      paginate = document.createElement('div');
      paginate.className = 'jdgm-paginate';
      paginate.setAttribute('data-per-page', PER_PAGE);
      container.parentNode.insertBefore(paginate, container.nextSibling);
    }
    paginate.innerHTML = '';

    if (totalPages <= 1) {
      paginate.style.display = 'none';
    } else {
      paginate.style.display = '';

      // First/prev
      if (page > 1) {
        paginate.appendChild(makePageLink(widget, 1, 'jdgm-paginate__first-page'));
        paginate.appendChild(makePageLink(widget, page - 1, 'jdgm-paginate__prev-page', 'prev'));
      }

      // Page numbers (show max 5 around current)
      var startPage = Math.max(1, page - 2);
      var endPage = Math.min(totalPages, page + 2);
      for (var p = startPage; p <= endPage; p++) {
        var cls = p === page ? 'jdgm-curt' : '';
        paginate.appendChild(makePageLink(widget, p, cls, null, p));
      }

      // Next/last
      if (page < totalPages) {
        paginate.appendChild(makePageLink(widget, page + 1, 'jdgm-paginate__next-page', 'next'));
        paginate.appendChild(makePageLink(widget, totalPages, 'jdgm-paginate__last-page'));
      }
    }

    onJudgemeReady(function() { reveal(widget); });

    // Scroll to widget top on page change (except first load)
    if (page > 1 || widget._hasRendered) {
      widget.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
    widget._hasRendered = true;
  }

  // Judge.me's setup run (widget_common.js, one synchronous jQuery-ready run)
  // shows its title and summary text, writes the average into the star box,
  // and then adds jdgm--done-setup-widget to the widget. Everything the module
  // reveals waits for that class, so that it appears in the same frame as
  // Judge.me's own header. If Judge.me never gets there, the module reveals
  // nothing, which is what the stock widget does too.
  function judgemeIsReady() {
    return widget.classList.contains('jdgm--done-setup-widget');
  }

  // Runs fn now if Judge.me's setup is done, else once when readyObserver
  // sees the class arrive (a mutation callback runs after the script run
  // that added the class and before the next paint).
  function onJudgemeReady(fn) {
    if (judgemeIsReady()) { fn(); return; }
    readyCallbacks.push(fn);
  }

  // The header: round the average Judge.me just wrote and show the star box
  // (which holds the average) and the average, hidden until now by
  // layout/theme.liquid's rule.
  function finishHeader() {
    var ratingEl = widget.querySelector('.jdgm-rev-widg[data-average-rating]');
    var stars = widget.querySelector('.jdgm-rev-widg__summary-stars');
    var averageEl = widget.querySelector('.jdgm-rev-widg__summary-average');
    // Judge.me writes the average with two decimals ("4.85"); show it to one,
    // rounded half up on those decimal digits (4.85 -> 4.9). Not toFixed(1):
    // 4.85 is not exact in binary, so Number("4.85").toFixed(1) is "4.8".
    // Only when the admin text is the bare "{{ average_rating }}", i.e. the
    // text is just that number: if it is anything else (e.g. the default
    // "4.87 out of 5"), leave it alone. Compared as numbers, because Judge.me
    // reads the attribute through jQuery's .data(), which prints "5.00" as
    // "5" and "4.90" as "4.9".
    if (ratingEl && averageEl) {
      var raw = ratingEl.getAttribute('data-average-rating');
      var target = averageEl.querySelector('.jdgm-link') || averageEl;
      var text = target.textContent.trim();
      if (/^\d+(\.\d+)?$/.test(text) && Number(text) === Number(raw)) target.textContent = roundRatingToTenth(raw);
    }
    // 'visible', not '': layout/theme.liquid's rule starts them hidden, and
    // clearing the inline value would leave that rule in force.
    if (stars) stars.style.visibility = 'visible';
    if (averageEl) averageEl.style.visibility = 'visible';
  }

  function reveal(widget) {
    var container = widget.querySelector('.jdgm-rev-widg__reviews');
    var paginate = widget.querySelector('.jdgm-paginate');
    // Format first (a no-op for reviews Judge.me already formatted), then
    // release the holds and show, all in one task so the box is laid out once.
    try { if (window.jdgm && jdgm.customizeReviews) jdgm.customizeReviews(); } catch (e) {}
    releaseBoxes();
    // 'visible', not '': layout/theme.liquid's rule starts both hidden, and
    // clearing the inline value would leave that rule in force.
    container.style.visibility = 'visible';
    if (paginate) paginate.style.visibility = 'visible';
    // After the release, so the picture loader measures the real layout.
    if (window.jdgm && jdgm.jQuery && jdgm.setupLazyLoadPicture) {
      try { jdgm.setupLazyLoadPicture(jdgm.jQuery(container).find('.jdgm-rev__pic-img')); } catch (e) {}
    }
  }

  // "4.85" -> "4.9": round half up on the decimal digits of Judge.me's
  // two-decimal string. Digits past the second are dropped (Judge.me writes
  // exactly two). Returns one decimal, so 5 -> "5.0".
  function roundRatingToTenth(raw) {
    var parts = String(raw).split('.');
    var hundredths = Number(parts[0]) * 100 + Number(((parts[1] || '') + '00').slice(0, 2));
    return (Math.floor((hundredths + 5) / 10) / 10).toFixed(1);
  }

  function makePageLink(widget, page, extraClass, rel, label) {
    var a = document.createElement('a');
    a.className = 'jdgm-paginate__page ' + (extraClass || '');
    a.setAttribute('data-page', page);
    a.setAttribute('aria-label', 'Page ' + page);
    a.setAttribute('tabindex', '0');
    a.setAttribute('role', 'button');
    if (rel) a.setAttribute('rel', rel);
    if (label) a.textContent = label;
    a.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      renderPage(widget, page);
    });
    return a;
  }
})();


// ============================================================================
// TEMP WORKAROUND — Bundlex "capture once" variant/property bug.
// Bundlex (volume-discount) initializes ONCE (guarded by
// window.bundlexWidgetInitialized) and caches the variant + line-item
// properties from the first bundle add. It does NOT re-read the product form
// on later adds in the same page session, so changing the variant or monogram
// and adding again re-adds the FIRST config — Shopify then merges it into the
// existing line (quantity bumps) instead of adding the new variant/monogram.
// A full page load re-runs Bundlex's init so it re-captures the current form.
//
// Fix: after a Bundlex bundle add, reload once when the cart drawer closes.
// Guarded so it only fires (a) on a page that actually has a Bundlex widget,
// and (b) when the bundled quantity went UP since this page loaded — so it
// reloads at most once per add and never loops on repeated open/close.
// Remove once Bundlex ships a re-read fix (reported to them separately).
// ============================================================================
(function bundlexReloadAfterBundleAdd() {
  function bundlexQty(cart) {
    return (cart.items || []).reduce(function (sum, it) {
      return sum + (it.properties && it.properties._bundlex ? it.quantity : 0);
    }, 0);
  }

  var baselineQty = null;
  fetch('/cart.js', { credentials: 'same-origin' })
    .then(function (r) { return r.json(); })
    .then(function (cart) { baselineQty = bundlexQty(cart); })
    .catch(function () {});

  function onDrawerClose() {
    // Only relevant where re-adding a bundle is possible (widget on this page).
    if (!document.querySelector('.bx-widget-container')) return;
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (baselineQty != null && bundlexQty(cart) > baselineQty) {
          window.location.reload();
        }
      })
      .catch(function () {});
  }

  function watchDialog(dialog) {
    if (dialog.__bxCloseWatch) return;
    dialog.__bxCloseWatch = true;
    var wasOpen = dialog.hasAttribute('open');
    new MutationObserver(function () {
      var isOpen = dialog.hasAttribute('open');
      if (wasOpen && !isOpen) onDrawerClose(); // open -> closed
      wasOpen = isOpen;
    }).observe(dialog, { attributes: true, attributeFilter: ['open'] });
  }

  function tryAttach() {
    var drawer = document.querySelector('cart-drawer-component');
    var dialog = drawer && drawer.querySelector('dialog');
    if (dialog) { watchDialog(dialog); return true; }
    return false;
  }

  // The Horizon cart bundle may build the drawer dialog after this runs.
  if (!tryAttach()) {
    var obs = new MutationObserver(function () { if (tryAttach()) obs.disconnect(); });
    obs.observe(document.documentElement, { childList: true, subtree: true });
    setTimeout(function () { obs.disconnect(); }, 10000);
  }
})();